export default __webpack_public_path__ + "static/media/@givusdt.1c0a6ea2.jpg";